<div (click)="toggleActivate()" [ngClass]="{ active: active$ | async }">
    <span class="tree-col"
        ><span class="spacer"> </span>
        <span>
            {{ item.name }}
        </span>
    </span>
    <span
        class="tree-col adjustment"
        [ngClass]="{ highlight: item.adjustedValue !== item.closingValue }"
        *ngIf="showAdjustments"
        >{{ totalAdjustedValue | finNumber }}</span
    >
    <span class="tree-col current-year">{{ item.closingValue | finNumber }}</span>
    <span class="tree-col">{{ item.openingValue | finNumber }}</span>
</div>
